module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "defaultModalStatus",
      "hide-footer": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'updateStatus') ? _c('UpdateStatus', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'updateArchive') ? _c('UpdateArchive', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f921e9da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/modal/Modal.vue
// module id = 3404
// module chunks = 0